import { LocalDate } from "@js-joda/core";
import { PatientMedicationProfileWithDetails } from "../../../messages/MedicationProfile";
import { isDefined } from "../../Generic/IsDefined";

function areSameDates(dateA: LocalDate | null, dateB: LocalDate | null) {
  if (!isDefined(dateA) && !isDefined(dateB)) {
    return true;
  }

  if (!isDefined(dateA) || !isDefined(dateB)) {
    return false;
  }

  return dateA.compareTo(dateB) === 0;
}

export function isEqualMedications(
  medicationA: PatientMedicationProfileWithDetails,
  medicationB: PatientMedicationProfileWithDetails
) {
  return (
    medicationA.id === medicationB.id &&
    medicationA.medicationId === medicationB.medicationId &&
    areSameDates(medicationA.from, medicationB.from) &&
    areSameDates(medicationA.until, medicationB.until) &&
    medicationA.frequency === medicationB.frequency &&
    medicationA.notes === medicationB.notes &&
    medicationA.dose === medicationB.dose
  );
}

export function findEqualMedication(
  medicationToFind: PatientMedicationProfileWithDetails,
  medications: PatientMedicationProfileWithDetails[]
) {
  for (const medication of medications) {
    if (isEqualMedications(medicationToFind, medication)) {
      return medication;
    }
  }

  return null;
}

export function isEqualMedicationsLists(
  medicationsListA: PatientMedicationProfileWithDetails[] = [],
  medicationsListB: PatientMedicationProfileWithDetails[] = []
) {
  const areAllMedicationsEqual = (
    listA: PatientMedicationProfileWithDetails[] = [],
    listB: PatientMedicationProfileWithDetails[] = []
  ) => {
    for (const medication of listA) {
      const sameMedication = findEqualMedication(medication, listB);
      if (!isDefined(sameMedication)) {
        return false;
      }
    }

    return true;
  };

  return (
    areAllMedicationsEqual(medicationsListA, medicationsListB) &&
    areAllMedicationsEqual(medicationsListB, medicationsListA)
  );
}
